import { PaymentType, SchemaTypes } from '@allesauto/graphql';

import { PriceFilterStateProps } from '@/store/redux/reducers/pages/pcp/filters/price';

import { createVehiclesFilterObject } from './createVehiclesFilterObject';
import { getParsedUrlQuery } from './getParsedUrlQuery';
import { getQueryParams } from './getQueryParams';

/**
 * PCP UTILITY FUNCTIONS
 */

export { createVehiclesFilterObject, getParsedUrlQuery, getQueryParams };

export const createVehiclesPagerObject = (pagerBase: any) => {
  const pager: SchemaTypes.SearchResultPager = {};

  if (pagerBase.limit && !isNaN(pagerBase.limit)) {
    pager.limit = pagerBase.limit;
  }

  if (pagerBase.page && !isNaN(pagerBase.page)) {
    pager.page = pagerBase.page;
  }

  return pager;
};

export const createVehiclesSortingObject = (sortingBase: any) => {
  const sorting: any = {};

  if (sortingBase?.subject) {
    sorting.subject = sortingBase.subject;
  }

  if (sortingBase?.direction) {
    sorting.direction = sortingBase.direction;
  }

  return sorting;
};

export const getDefaultPriceRange = (priceFacets: any) =>
  priceFacets?.find(
    (price: any) => price.key === PaymentType.CashRange
  ) as PriceFilterStateProps;

export const getPagesCount = (aggregation: any, itemsPerPage: any) =>
  aggregation && aggregation > itemsPerPage
    ? Math.ceil(aggregation / itemsPerPage)
    : 1;
